import { computed, type ComputedRef } from 'vue';

import { usePolicyContext } from '@/auth/usePolicyContext';
import { NAVIGATION, type NavItem } from './navigation.config';

export function useNavigation(): { items: ComputedRef<NavItem[]> } {
  const context = usePolicyContext();

  const visible = (items: readonly NavItem[]): NavItem[] =>
    items
      .filter(item => item.policy.isSatisfiedBy(context.value))
      .map(item =>
        item.children ? { ...item, children: visible(item.children) } : item,
      )
      .sort((a, b) => a.weight - b.weight);

  return { items: computed(() => visible(NAVIGATION)) };
}
